import { TriggerActionCategory } from "@octopusdeploy/octopus-server-client";
import React from "react";
import EditScheduledTriggers from "./CreateOrEditScheduledTriggerPage";
interface DeploymentScheduledTriggerPageProps {
    spaceId: string;
    projectSlug: string;
    triggerId: string;
}
export function DeploymentScheduledTriggerPage({ spaceId, projectSlug, triggerId }: DeploymentScheduledTriggerPageProps) {
    return <EditScheduledTriggers create={false} triggerActionCategory={TriggerActionCategory.Deployment} spaceId={spaceId} projectSlug={projectSlug} triggerId={triggerId}/>;
}
